var React = require('react');

function IconCaretLeft (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"#031929","strokeWidth":"2","points":"7,1.3 1.3,7 7,12.7 "}));
}

IconCaretLeft.defaultProps = {"width":"8px","height":"14px","viewBox":"0 0 8 14"};

module.exports = IconCaretLeft;

IconCaretLeft.default = IconCaretLeft;
